import { render, staticRenderFns } from "./CompContestsActiveContestCard.vue?vue&type=template&id=2450b780"
import script from "./CompContestsActiveContestCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompContestsActiveContestCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports